import $ from "jquery";

$(function () {
  $('[data-bs-toggle="tooltip"]').tooltip();
});
